import type { ColumnContext, ColumnPassThroughAttributes, ColumnProps } from 'primevue/column';
import Column from 'primevue/column';
import type { PassThrough } from 'primevue/ts-helpers';
import type { Component } from 'vue';
import { h } from 'vue';

/**
 * Contains direct pass through options for the Column component
 * that proved hard to overwrite in DsDataTable
 */
const DsColumnPassThroughOptions: PassThrough<ColumnPassThroughAttributes> = {
    headerCell: {
        class: 'py-3 px-4 bg-ds-gray-100',
    },
    headerTitle: {
        class: 'text-content-sm leading-none whitespace-nowrap',
    },
    bodyCell({ props }: { props: DsColumnProps; context: ColumnContext }) {
        const classes = ['tbody-cell'];

        // tricky part: when using a shorthand prop it'll come as an empty string at this point
        const clickDisabled = props.clickDisabled === true || props.clickDisabled === '';
        if (clickDisabled) {
            classes.push('click-disabled');
        }

        return {
            class: classes,
        };
    },
};

export type DsColumnProps = ColumnProps & {
    // Disable click events on this column's cells when clickableRows is enabled on DsDataTable
    // empty string reflects an unexpected behavior with shorthand props in which case it comes as ''
    clickDisabled?: boolean | '';
};

/** Proxy for the Column component with a DsName and predefined pass through options */
export const DsColumn: Component<DsColumnProps> = h(Column, {
    pt: DsColumnPassThroughOptions,
});
